import { useNavigate } from 'react-router-dom';
import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';

import StickyHeader from '../../../components/StickyHeader';

import { Button } from '@peacecover/component';

const ReportEventCompleteEditPage = () => {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();

  const handleNavigateToCollection = () => {
    navigate('/collections?boxTabIndex=1');
  };
  return (
    <>
      <StickyHeader
        title={t('ReportEventCompleteEditPage.pageTitle', { defaultValue: '제보하기' }) as string}
        alwaysShowTitle={true}
        showBackButton={true}
        showTitle={true}
      />
      <div
        className="flex flex-col min-h-screen items-center pt-[calc(54px+env(safe-area-inset-top))] pb-[calc(128px+env(safe-area-inset-bottom))] bg-repeat"
        style={{
          backgroundImage: `url('/assets/backgrounds/report/report_complete_${colorMode === 'dark' ? 'dark' : 'light'}.png')`,
          backgroundRepeat: 'round'
        }}
      >
        <div className="flex flex-col items-center gap-[12px] mt-[203px] leading-none">
          <h1 className="text-[26px] font-bold text-text-main-lv1">
            {t('ReportEventCompleteEditPage.title', {
              defaultValue: '소중한 수정요청 감사해요!'
            })}
          </h1>
          <p className="text-[24px] font-medium text-text-main-lv2">
            {t('ReportEventCompleteEditPage.description', {
              defaultValue: '확인 후 반영하도록 할게요.'
            })}
          </p>
        </div>
        <div className="fixed flex mb-[calc(10px+env(safe-area-inset-bottom))] flex-col gap-[8px] bottom-0 px-[20px] py-[10px] w-full">
          <Button
            size="large"
            className="w-full text-[17px] font-semibold"
            onClick={handleNavigateToCollection}
          >
            {t('confirm')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ReportEventCompleteEditPage;
